export default "__VITE_ASSET__B5MW6HF4__"